<template>
  <MapContour
    v-if="hasLocation"
    :options="options"
    @load="loadMap"
    :sources="sources"
    :layers="layers"
    :marker="true"
    @markerMove="emit('markerMove', $event)"
  />
</template>
<script setup>
import { bbox } from "@turf/turf";
const emit = defineEmits(["markerMove"]);
const props = defineProps({
  location: {
    type: Object,
    required: true,
  },
  geojson: {
    type: Object,
    required: true,
  },
  options: {
    type: Object,
    default: {},
  },
});
let map;
const hasLocation = computed(() => {
  return isNumber(props.location?.latitude) && isNumber(props.location?.longitude);
});
const options = computed(() => {
  return {
    center: [props.location.longitude, props.location.latitude],
    bounds: bbox(props.geojson),
    fitBoundsOptions: { padding: 20 },
    style: "/styles/elevation-color.json",
    ...props.options,
  };
});
const sources = computed(() => [
  {
    id: "features",
    type: "geojson",
    data: props.geojson,
  },
]);
const minMaxElevations = computed(() => {
  const elevations = props.geojson.features.map((f) => f.properties.ele);
  return [Math.min(...elevations), Math.max(...elevations)];
});
const layers = computed(() => [
  {
    id: "feature-points",
    type: "circle",
    source: "features",
    layout: {
      "circle-sort-key": ["to-number", ["get", "rank"]],
    },
    paint: {
      // "circle-radius": 6,
      // adjust size based on elevation
      "circle-radius": [
        "interpolate",
        ["linear"],
        ["get", "ele"],
        minMaxElevations.value[0],
        3,
        minMaxElevations.value[1],
        6,
      ],
      "circle-color": "#FC7A24",
      "circle-opacity": 0.75,
    },
  },
  {
    id: "feature-labels",
    type: "symbol",
    source: "features",
    layout: {
      "text-font": ["Open Sans Bold"],
      "text-field": [
        "format",
        ["get", "name_int"],
        { "font-scale": 1 },
        "\n",
        {},
        ["concat", ["number-format", ["get", "ele_ft"], {}], " ft"],
        {
          "font-scale": 1,
          "text-font": ["literal", ["Open Sans Regular"]],
        },
      ],
      "text-size": 14,
      "text-justify": "auto",
      "text-anchor": "top",
      "text-max-width": 8,
      "text-radial-offset": 0.7,
      "symbol-sort-key": ["to-number", ["get", "rank"]],
    },
    paint: {
      "text-color": "#000",
      "text-halo-color": "#fff",
      "text-halo-width": 1.25,
    },
  },
]);

function loadMap(mapValue) {
  map = mapValue;
}
</script>
